export default {
  root: {
    borderRadius: '2px'
  },
  notchedOutline: {
    borderColor: 'rgba(0,0,0,0.15)'
  }
};
